import { render, staticRenderFns } from "./RecommendationHubView.vue?vue&type=template&id=2e85c882"
import script from "./RecommendationHubView.vue?vue&type=script&lang=js"
export * from "./RecommendationHubView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports